import React from "react";
import { useDispatch, useSelector } from "react-redux";

import { updateComplianceFilters } from "@/reducers/clientcandidatedetail";

import ComplianceAction from "./ComplianceAction";
import { ComplianceRightActions } from "./ComplianceRightActions";
import ComplianceType from "./ComplianceType";
import { SelectedCountText } from "../candidates/Listing/common/SelectedCountText";
import TableSearch from "../dataTables/TableSearch";

/**
 * Function to render the Compliance Listing Top component.
 *
 * @return {JSX.Element} The rendered Compliance Listing Top component
 */
const ComplianceListingTop = () => {
  const dispatch = useDispatch();
  const { complianceFilters } = useSelector(
    (state) => state.clientCandidateDetail,
  );
  const { sideBarCollapsed } = useSelector((state) => state.clientCommon);

  return (
    <div className="ComplianceListingTop_Wrapper flex w-full flex-col justify-between gap-3 md:flex-row md:gap-0 py-3 md:py-0">
      <div
        className={`content flex items-center gap-2 overflow-x-auto ${sideBarCollapsed ? "content-collapsed" : "content-expanded"} `}
      >
        <ComplianceType />
        <ComplianceAction />
        <SelectedCountText selectedCount={0} />
      </div>
      <div className="flex items-center gap-2">
        <ComplianceRightActions />

        <TableSearch
          val={complianceFilters.search}
          handleChange={(e) =>
            dispatch(updateComplianceFilters({ search: e.target.value }))
          }
        />
      </div>
    </div>
  );
};

export default ComplianceListingTop;
